<template>
  <div>

    <nav class="navbar customNavbar">
      <div class="navbar-brand">
        <a v-on:click="root()">
          <img class="logoClass" src="/static/logo.png">
        </a>
      </div>
      <div class="navbar-end">
        <a class="navbar-item customNavbarItem" v-on:click="root()">Inicio</a>
        <a class="navbar-item customNavbarItemSelected" >Nosotros</a>
        <a class="navbar-item customNavbarItem" v-on:click="products()">Productos</a>
        <a class="navbar-item customNavbarItem" v-on:click="news()">Noticias</a>
        <a class="navbar-item customNavbarItem" v-on:click="contact()">Contacto</a>
        <a class="navbar-item customNavbarItem" v-if="isLogged" v-on:click="logout()">Cerrar Sesión</a>
        <a class="navbar-item customNavbarItem" v-else v-on:click="login()">Iniciar Sesión</a>
      </div>
    </nav>

    <section class="section">
      <div class="columns">
        <div class="column"></div>
        <div class="column is-7">
          <h2 class="title is-2">Acerca de Hipromeasa</h2>
          <br/>
          <div class="tile is-ancestor">
            <div class="tile is-6 is-vertical is-parent">
              <div class="tile is-child">
                <p class="title is-6 infoTitle">Higiene, Protección y Medio Ambiente, S.A.</p>
                <p class="infoClass">
                  Somos una empresa centroamericana dedicada a importar, producir y distribuir productos utilizados para el combate y la protección contra las plagas que afectan la higiene y la salud de los seres humanos, sus animales, sus productos de manufactura, sus mercancías en almacenamiento y su entorno. <br/><br/>
                  Nuestra empresa cuenta con personal con muchos años de experiencia en los campos de higiene, protección y medio ambiente en la región de Centroamérica y El Caribe, lo que nos permite brindar asesoría técnica y capacitación calificadas en el control de plagas, incluyendo el manejo integrado de las mismas,
                  la selección de las mejores alternativas químicas de control en caso de ser necesarias, recomendaciones de uso de productos y técnicas de aplicación. Todo esto con las debidas consideraciones costo/beneficio, a la par de la efectividad, la seguridad para los operadores y los habitantes y el respeto del medio ambiente.<br/><br/>
                  Contamos en nuestro portafolio con productos reconocidos de prestigiados fabricantes, así como con una amplia gama de productos propios formulados localmente bajo los más altos estándares de calidad, con ingredientes activos certificados bajo las normas ISO, y a la medida de sus necesidades.<br/><br/>
                </p>
              </div>
            </div>
            <div class="tile is-vertical is-parent">
              <div class="tile is-child">
                <p class="title is-6 infoTitle">Nuestra Misión</p>
                <p class="infoClass">
                  Alcanzar la posición de líderes, proveyendo productos y servicios profesionales adaptados a cada uno de los mercados que servimos, a un precio justo, que proporcionen ventajas técnicas, económicas y ecológicas, con una atención de primera clase, ofrecida por personas comprometidas con la excelencia, para la satisfacción de nuestros clientes.
                </p>
              </div>
              <div class="tile is-child">
                <p class="title is-6 infoTitle">Nuestra Visión</p>
                <p class="infoClass">
                  Ser los líderes en cada uno de los mercados que servimos, a través de la maximización de la calidad en el servicio, los niveles de venta, los porcentajes de participación de mercado, y la rentabilidad de la empresa.
                </p>
              </div>
              <div class="tile is-child">
                <p class="title is-6 infoTitle">Nuestros Objetivos</p>
                <p class="infoClass">
                  Nuestro compromiso es la permanente actualización, modernización y búsqueda de más y mejores alternativas de combate contra las plagas, de manera que podamos ofrecer constantemente a nuestros clientes más opciones, tecnología de vanguardia y soluciones adecuadas a sus problemas de control de plagas.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="column"></div>
      </div>

      <br/>
      <hr style="margin-bottom: 0;">
      <br/>

      <div class="columns">
        <div class="column"></div>
        <div class="column is-half">
          <h2 class="title is-3">Contactenos</h2>
          <a class="button customButton" v-on:click="contact()">Click aqui</a>
        </div>
        <div class="column"></div>
      </div>
    </section>
    <footer class="footer">
      <div class="container">
        <div class="columns">
          <div class="column">
            <img class="logoClass" src="/static/logo.png">
            <p class="footerInfo">
              Nuestra misión es aportar soluciones para el control integrado de plagas que afectan la salud, la
              tranquilidad y la economía del hombre en las diferentes áreas donde se desenvuelve, por medio de
              asesoría técnica profesional, capacitación y productos efectivos a precios justos.
            </p>
          </div>
          <div class="column is-4">
            <a href="https://www.google.com/maps/@14.5945742,-90.5766572,17.25z" >
              <img width="400px" height="300px" class="mapInfo" src="/static/images/newmap.png"/>
            </a>
          </div>
          <div class="column">
            <p class="footerContact">
              2da calle 18-87 sector B-1<br/>
              Ciudad San Cristóbal zona 8 de Mixco<br/>
              Guatemala<br/>
              (502) 2478-1179 / 80 / 82 / 99<br/><br/>
              <a href="https://wa.me/50240251346">
                <img width="20px" height="20px" src="/static/images/whatsapp-icon.png" class="iconImage">
                WhatsApp: (502) 4025 - 1346
              </a><br/><br/>
              <a href="mailto:ventas@hipromeasa.com">
                <img width="20px" height="20px" src="/static/images/mail-icon.png" class="iconImage">
                E-Mail: ventas@hipromeasa.com
              </a><br/><br/>
              <a href="https://www.facebook.com/hipromeasa">
                <img width="20px" height="20px" src="/static/images/facebook-icon.png" class="iconImage">
                Estamos en Facebook
              </a>
            </p>
          </div>
        </div>
        <div class="content has-text-centered">
          <p class="footerLast">2025 - Todos los derechos reservados</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'landing',
  data () {
    return {
      isLogged: localStorage.getItem('email') !== null
    }
  },
  methods: {
    root: function () {
      this.$router.push('/')
    },
    logout: function () {
      localStorage.removeItem('email')
      localStorage.removeItem('token')
      this.isLogged = false
      this.$router.push('/')
    },
    about: function () {
      this.$router.push('/about')
    },
    products: function () {
      this.$router.push('/products')
    },
    news: function () {
      this.$router.push('/news')
    },
    contact: function () {
      this.$router.push('/contact')
    },
    login: function () {
      this.$router.push('/login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logoClass {
    height: 60px;
    width: 220px;
    margin-left: 20px;
    margin-top: 10px;
  }
  .imageStyle {
    margin-left: auto;
    margin-right: auto;
  }
  .infoClass {
    font-size: small;
    text-align: justify;
  }
  .infoTitle {
    text-align: left;
  }
  .footerInfo {
    margin-left: 60px;
    margin-right:60px;
    text-align: center;
    font-size: small;
  }
  .footerContact {
    text-align: left;
    font-size: small;
    margin-left: 100px;
    margin-right:80px;
    margin-top: 30px;
  }
  .footerLast {
    font-size: small;
    margin-bottom: 0px;
    margin-top: -10px;
  }
  .mapInfo {
    padding-top: 30px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .iconImage {
    vertical-align: middle;
    padding-bottom: 2px;
  }
</style>



// WEBPACK FOOTER //
// AboutComponent.vue?374b8520